import { useEffect } from "react";

export const useDebouncedEffect = (callback, dependancies, delay) => {
    useEffect(() => {
        const handler = setTimeout(() => callback(), delay);
        return () => clearTimeout(handler);
    }, [...(dependancies || []), delay]);
};
